import React from 'react';
import Box from '@mui/material/Box';
import { CardProps, Grid, Typography } from '@mui/material';
import type { DropdownOption } from 'types/common/DropdownOption';

type StepperBoxProps = {
  isSelected: boolean;
  handleItemClick: (id: string) => void;
  option: DropdownOption;
  standardView?: boolean;
};
export const StepperBox = ({
  isSelected,
  handleItemClick,
  option,
  standardView = true,
}: StepperBoxProps) => {
  const selectedStyle: CardProps['sx'] = {
    bgcolor: (theme) => theme.palette.primary.main,
    color: (theme) => theme.palette.primary.light,
  };
  const unSelectedStyle: CardProps['sx'] = {
    bgcolor: (theme) => (standardView ? theme.palette.primary.light : 'white'),
    color: (theme) => theme.palette.primary.main,
    borderColor: (theme) =>
      standardView ? theme.palette.primary.light : theme.palette.borderColor,
  };

  return (
    <Grid
      item
      component={'div'}
      justifyContent='center'
      alignItems='center'
      md={standardView ? 4 : 'auto'}
      xs={standardView ? 6 : 'auto'}
    >
      <Box
        display='flex'
        justifyContent='center'
        alignItems='center'
        width={standardView ? '100%' : 'auto'}
        onClick={() => handleItemClick(option.value as string)}
        border='1px solid transparent'
        sx={{
          aspectRatio: standardView ? '2/1' : 'auto',
          borderRadius: '10px',
          boxShadow: (theme) => theme.shadows[1],
          cursor: 'pointer',
          transition: 'transform 0.1s',
          ...(isSelected ? selectedStyle : unSelectedStyle),
          '&:hover': {
            boxShadow: (theme) => theme.shadows[2],
          },
          '&:active': { transform: 'scale(0.98)' },
        }}
      >
        <Typography
          textAlign='center'
          fontSize='16px'
          fontFamily='Mont-SemiBold'
          sx={{
            padding: 2,
          }}
        >
          {option.label}
        </Typography>
      </Box>
    </Grid>
  );
};
